export default {"src":"/_next/static/media/burningMoney_24.d4274a4a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};